/**
 * Checkout AR Channel Invite — DEPRECATED.
 *
 * MercadoPago está deshabilitado para checkouts. Esta ruta queda solo como
 * redirect a /checkout-channel-invite (Stripe) preservando query params.
 * Borrar cuando todos los links externos apunten directo al nuevo flujo.
 */

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function CheckoutArChannelInvite() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    // Default pack si la URL legacy no lo trae.
    if (!params.has("pack")) params.set("pack", "channel_invite");
    if (!params.has("country")) params.set("country", "AR");
    window.location.replace(`/checkout-channel-invite?${params.toString()}`);
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4" />
        <p className="text-gray-400">Redirigiendo al checkout…</p>
      </div>
    </div>
  );
}
